import(/* webpackMode: "eager" */ "/vercel/path0/app/furniture/page.tsx");
